import useAuth from 'src/hooks/useAuth';
import useSWR from 'swr';
import { fetcher } from 'src/api/API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

const useGetGrantedSubAccounts = (
  selectedGroups,
  includeArchived = false
) => {
  const { getAccessToken } = useAuth();
  const { data, error, mutate, isValidating } = useSWR(
    [`granted_subaccounts?include_archived=${includeArchived}`, getAccessToken],
    fetcher,
    { revalidateOnFocus: false }
  );
  
  let subAccounts = [];
  if (data && data?.length && selectedGroups?.length) {
    subAccounts = data.filter(accounts => selectedGroups.includes(accounts.groupName))?.map(a => a.subAccountNamesAndRoles.map(acct => {
      return {
        name: acct.name,
        isActive: acct.isActive
      }
    })).flat();
  } else if (data && data?.length && !selectedGroups?.length) {
    subAccounts = data.map(a => a.subAccountNamesAndRoles.map(acct => {
      return {
        name: acct.name,
        isActive: acct.isActive
      }
    })).flat();
  }

  const errorMsg = error ? extractApiErrorMessage(error) : '';

  return {
    data: !error ? subAccounts : [],
    isLoading: !error && !data,
    isValidating,
    isError: errorMsg,
    mutate
  };
};

export default useGetGrantedSubAccounts;
